export default {
  pageTitle: 'Events',
  pageDesc: '管理当前工作区下的活动（个人空间为本人活动，公司空间为该公司活动）。',
  noAccessAlert: '暂无活动管理权限，请联系管理员授权。',
  searchPlaceholder: 'Search name, location, or description',
  addEvent: 'New event',
  editEvent: 'Edit event',
  emptyTable: 'No events yet',
  eventName: 'Event name',
  requiresRegistration: 'Registration',
  registrationApproval: 'Approval',
  approvalRequired: 'Required',
  approvalAuto: 'Auto-approve',
  eventCity: 'City / region',
  eventAddress: 'Address',
  eventIntro: 'Description',
  creator: 'Created by',
  createdAt: 'Created at',
  namePlaceholder: 'Enter event name',
  registrationNeedsApproval: 'Registration approval',
  cityPlaceholder: 'e.g. Guangzhou, Guangdong',
  citySelectPlaceholder: 'Select province / city',
  cityAbroadPlaceholder: 'Enter a foreign address',
  cityRequired: 'Select a city, or enter a foreign address',
  addressPlaceholder: 'Enter venue address',
  introPlaceholder: 'Enter event description',
  nameRequired: 'Event name is required',
  switchCompanyFirst: 'Please switch to company workspace first',
  createSuccess: 'Event created',
  createFailed: 'Failed to create event. Please try again.',
  createModal: {
    title: 'Basic event info',
    startTime: 'Start time',
    endTime: 'End time',
    timeRange: 'Event time',
    timeRangeRequired: 'Select event time range',
    city: 'City / region',
    startRequired: 'Select start time',
    endRequired: 'Select end time',
    addressRequired: 'Enter venue address',
    introRequired: 'Enter event description',
    endAfterStart: 'End time must be after start time',
    submit: 'Save & create'
  },
  createSuccessModal: {
    title: 'Event created!',
    desc: 'Basic info is saved.\nYou can finish page design now,\nor continue editing later from the event list.',
    goConfig: 'Finish setup now',
    later: 'Later'
  },
  updateSuccess: 'Event updated',
  loadFailed: 'Failed to load event details. Please try again.',
  deleteConfirmTitle: 'Delete event',
  deleteConfirmMessage: 'Delete event "{name}"?',
  deleteConfirmOk: 'Delete',
  deleteSuccess: 'Deleted',
  eventCreateGate: {
    needEventFirst: 'Save event info first to create the activity, then continue on other pages.'
  },
  wizardNav: {
    primaryAria: 'Event wizard primary navigation',
    primaryEvent: 'Event',
    primaryDecoration: 'Design',
    primaryRegistration: 'Reg.',
    backToList: 'Back to events',
    close: 'Close',
    settingsLabel: 'Event settings',
    groupBasic: 'Basics',
    groupRegistration: 'Registration',
    groupPageDecoration: 'Page design',
    groupMore: 'More',
    eventInfo: 'Basic info',
    location: 'Location',
    registration: 'Registration',
    registrationForm: 'Questionnaire',
    share: 'Sharing',
    shareTemplate: 'Share templates',
    micrositeCreate: 'Page design',
    activityConfig: 'Event config',
    schedule: 'Schedule',
    regConfig: 'Registration setup',
    seatRec: 'Seat editor',
    transferCfg: 'Transfers',
    hotelCfg: 'Hotels',
    diningCfg: 'Dining',
    pickup: 'Shuttle',
    dining: 'Meals',
    seating: 'Seating',
    checkin: 'Check-in management',
    toggleDecoration: 'Expand or collapse event config'
  },
  eventInfo: {
    pageTitle: 'Basic info',
    lastSaved: 'Last saved',
    saveBtn: 'Save event info',
    sectionBasic: '📋 Basic info',
    helpTitle: 'Tips',
    helpDesc: 'Set basic info, location, and registration here. Use the province/city cascader for event location.'
  },
  eventLocation: {
    pageTitle: 'Location',
    helpTitle: 'Tips',
    helpDesc: 'Set city and venue address shown on registration and event pages.'
  },
  eventRegistration: {
    pageTitle: 'Registration',
    helpTitle: 'Tips',
    helpDesc: 'Enable registration for sign-ups; turn on approval if entries must be reviewed.'
  },
  /** Activity wizard · share poster template (preview/download only) */
  shareTpl: {
    pageTitle: 'Share template',
    generatePoster: 'Generate poster',
    sectionTemplate: 'Poster templates',
    sectionContent: 'Share content',
    tplBlue: 'Classic blue',
    tplBluePurple: 'Classic blue',
    tplDarkTech: 'Dark tech',
    tplFreshGreen: 'Fresh green',
    tplWarmOrange: 'Warm orange',
    shareTitle: 'Title',
    shareTitlePlaceholder: 'Enter a title',
    shareSubtitle: 'Subtitle',
    shareSubtitlePlaceholder: 'Enter a subtitle',
    shareDesc: 'Subtitle',
    shareDescPlaceholder: 'Enter a subtitle',
    hostLabel: 'Host',
    hostPlaceholder: 'Enter host name',
    posterCover: 'Cover image',
    posterCoverHint: 'Approx. 16:9, JPG / PNG, max 3MB',
    posterCoverUpload: 'Upload cover',
    posterCoverUploading: 'Uploading…',
    posterCoverUploadSuccess: 'Poster cover uploaded',
    posterCoverUploadFailed: 'Poster cover upload failed',
    posterCoverClear: 'Remove cover',
    posterCoverPlaceholder: 'Upload a cover',
    posterCta: 'Long-press to scan & join',
    posterAttr: 'Powered by Bandu Event OS',
    qrHidden: 'QR hidden',
    displayItems: 'Show on poster',
    showTime: 'Event time',
    showLocation: 'Venue',
    showHost: 'Host',
    showQr: 'Event home QR',
    shareLink: 'Share link',
    activityLink: 'Event link',
    copy: 'Copy',
    copySuccess: 'Link copied',
    copyFailed: 'Copy failed',
    homeLinkHint: 'Points to this event’s microsite home (same as decoration preview)',
    noHomeLinkHint: 'No microsite home yet. Create and set a home page under Page decoration',
    noHomeLinkPlaceholder: 'No microsite home link',
    qrNeedHome: 'Set a microsite home first',
    preview: 'Preview',
    downloadPng: 'Download poster (PNG)',
    downloadSuccess: 'Poster downloaded',
    downloadFailed: 'Download failed',
    brand: 'Bandu · Event OS',
    titleEmptyPlaceholder: '(No title)',
    metaUnset: 'Not set',
    sectionWechatShare: 'WeChat share',
    wechatShareTip: 'Configure the WeChat share card title, subtitle and cover. Saved together with the poster title/description.',
    wechatTitle: 'Share title',
    wechatTitlePlaceholder: 'Optional; falls back to the event name',
    wechatTitleFallback: '(Uses event name)',
    wechatSubtitle: 'Subtitle',
    wechatSubtitlePlaceholder: 'Optional, shown under the title',
    wechatSubtitleFallback: 'Bandu · Event',
    wechatImage: 'Share image',
    wechatImageHint: 'Recommended 500×500px, JPG / PNG, max 3MB',
    wechatImageUpload: 'Upload cover',
    wechatImageUploading: 'Uploading…',
    wechatImageUploadSuccess: 'Share image uploaded',
    wechatImageUploadFailed: 'Share image upload failed',
    wechatImageClear: 'Remove image',
    wechatImageTypeError: 'Only JPG / PNG images are supported',
    wechatImageSizeError: 'Image must be 3MB or smaller',
    saveShare: 'Save share settings',
    saveShareSuccess: 'Share settings saved',
    saveShareFailed: 'Failed to save share settings',
    wechatPreview: 'WeChat card preview',
    wechatThumbPlaceholder: 'Cover'
  },
  /** Activity wizard · registration setup */
  regSetup: {
    sectionBasic: 'Basic settings',
    sectionAdvanced: 'Advanced settings',
    selectForm: 'Registration form',
    selectFormHint: 'Choose the questionnaire for this event',
    selectFormPlaceholder: 'Select a registration form',
    formStatusDraft: 'Draft',
    formRequired: 'Please select a registration form',
    formLockedTitle: 'Notice',
    formLockedConfirm: 'Registration settings have been saved. The questionnaire cannot be changed.',
    saveBindTitle: 'Confirm',
    saveBindConfirm: 'The questionnaire cannot be changed after selection. Confirm?',
    proxyLockedTip: '🔒 Enable “Allow group registration” to edit contact list',
    proxyNeedBindTip: 'Click “Save settings” to bind the form before adding contacts',
    saveSettingsBtn: 'Save settings',
    saveBtn: 'Save registration settings',
    saveSuccess: 'Registration settings saved',
    saveFailed: 'Save failed',
    loadFormsFailed: 'Failed to load questionnaires',
    loadFormFailed: 'Failed to load questionnaire settings',
    noForms: 'No questionnaires yet. Create one in Questionnaires first.',
    goFormManage: 'Go to Questionnaires',
    formManageTip: 'If no form is available, create one in Questionnaire Management first.',
    goConfigure: 'Go to setup →',
    statsPageTitle: 'Registration statistics',
    statsExport: 'Export report',
    statsExportSoon: 'Export is coming soon',
    statsNeedForm: 'Bind a questionnaire in Registration settings first',
    statsLoadFailed: 'Failed to load statistics',
    statsTotal: 'Total registrations',
    statsSelf: 'Individual',
    statsProxy: 'Team (proxy)',
    statsAvgDaily: 'Avg. daily',
    statsProxyDist: 'Proxy distribution',
    statsProxyDistEmpty: 'No proxy registration data yet',
    statsTrend7d: 'Trend (last 7 days)',
    statsTrendUnit: 'Unit: people',
    statsTrendTotal: '7-day total',
    statsTrendAvg: 'Daily avg',
    statsTrendPeak: 'Peak',
    statsPeopleUnit: '',
    statsFeeIncome: 'Fee income',
    statsFeeRegistration: 'Registration fee',
    statsFeeHotel: 'Hotel',
    statsFeeMeal: 'Meals',
    statsFeeShuttle: 'Shuttle',
    statsFeePending: '(coming soon)',
    statsReview: 'Review status',
    statsReviewApproved: 'Approved',
    statsReviewPending: 'Pending',
    statsReviewRejected: 'Rejected',
    statsDeadlinePrefix: 'Deadline: {time}',
    statsDeadlineRemainMid: 'days left:',
    statsDeadlineRemainSuffix: '',
    statsDeadlineTodayMid: 'due today',
    statsDeadlinePassedMid: 'ended',
    statsDeadlinePassedSuffix: 'day(s) ago',
    mailTemplate: {
      sectionTitle: 'Invite email template',
      hint: 'One template per activity. Empty subject or body falls back to system defaults. Use the buttons below to insert variables.',
      subject: 'Subject',
      subjectPlaceholder: '{{activityName}} questionnaire invite',
      body: 'Body',
      bodyPlaceholder: 'Write the email body, e.g. Hi, please open the invite link to fill the form…',
      insertPlaceholder: 'Insert variable',
      placeholderHelp: 'Variable reference',
      phInsertAs: 'Inserts as {token}',
      imageNotSupported: 'Images are not supported in the email body',
      saveBtn: 'Save template',
      saveSuccess: 'Email template saved',
      saveFailed: 'Failed to save email template',
      loadFailed: 'Failed to load email template',
      updatedAt: 'Updated: {time}',
      ph: {
        activityName: 'Activity name',
        formTitle: 'Registration form title',
        recipientName: 'Contact name',
        magicLinkUrl: 'Invite link',
        linkExpireDays: 'Link validity (days)',
        appName: 'App name'
      }
    }
  },
  schedule: {
    pageTitle: 'Schedule',
    helpTitle: 'Tips',
    helpDesc: 'Manage sessions under this event, grouped by date.',
    add: 'Add',
    addAgenda: 'Add session',
    edit: 'Edit',
    delete: 'Delete',
    colName: 'Session name',
    colAgendaName: 'Session name',
    colTime: 'Start – end',
    colTimeRange: 'Time',
    colLocation: 'Location',
    colVenue: 'Venue',
    colSortOrder: 'Order',
    colIntro: 'Description',
    colActions: 'Actions',
    formTitleAdd: 'Add session',
    formTitleEdit: 'Edit session',
    formSectionBasic: 'Basic info',
    formStart: 'Start',
    formEnd: 'End',
    formRegion: 'Region',
    formAddress: 'Address',
    formPlace: 'Place',
    formSortOrder: 'Order',
    regionPlaceholder: 'Province / city / district',
    regionAbroadPlaceholder: 'Enter a foreign address',
    addressPlaceholder: 'Enter detailed address',
    placePlaceholder: 'Enter place',
    sortOrderHint: 'For the same day, smaller values appear first. Equal values follow the start time.',
    sortOrderInvalid: 'Order must be a non-negative integer',
    dragSortHint: 'Drag to reorder sessions on the same day',
    sortSaved: 'Order saved',
    sortSaveFailed: 'Failed to save order. The original order has been restored.',
    introTip: 'Optional. Shown on the decorated session detail page if you use microsite decoration.',
    submitAdd: 'Confirm add',
    submitEdit: 'Save session',
    backToList: 'Back to list',
    formHelpDesc: 'Fill in session name, time, location and description. Fields marked * are required.',
    emptyList: 'No sessions yet',
    emptyDay: 'No sessions',
    unknownDate: 'No date',
    activityTimeRangeHint: 'Selectable time range based on [activity start–end]: {range}',
    needActivityTimeFirst: 'Please set the activity start and end time in Event Info first',
    timeOutOfActivityRange: 'Must be within the activity time range',
    namePlaceholder: 'Enter session name',
    introPlaceholder: 'Enter description',
    nameRequired: 'Session name is required',
    startRequired: 'Start time is required',
    endRequired: 'End time is required',
    endAfterStart: 'End time must be after start time',
    regionRequired: 'Select a region, or enter a foreign address',
    addressRequired: 'Address is required',
    createSuccess: 'Session added',
    updateSuccess: 'Session updated',
    saveFailed: 'Save failed',
    deleteConfirmTitle: 'Delete sessions',
    deleteConfirmMessage: 'Delete {count} session(s)?',
    deleteSuccess: 'Deleted',
    deleteFailed: 'Delete failed',
    loadFailed: 'Failed to load schedule'
  },
  checkin: {
    tabSettings: 'Basic settings',
    tabUsers: 'Attendee list',
    tabFields: 'Display fields',
    tabSuccess: 'Success page',
    tabPage: 'Page design',
    create: 'New check-in',
    createSuccess: 'Check-in created',
    empty: 'No check-ins yet',
    name: 'Name',
    namePh: 'Enter check-in name',
    nameRequired: 'Name is required',
    colCheckinName: 'Name',
    colMeeting: 'Session',
    colSigned: 'Signed / list',
    colEntry: 'Check-in URL',
    colScanEntry: 'Scan desk',
    meetingNone: 'Not bound to a session',
    openEdit: 'Settings',
    copyH5: 'Copy URL',
    copyEntry: 'Copy',
    qrBtn: 'QR',
    backToList: 'Back to list',
    deleteConfirmTitle: 'Delete check-in',
    deleteConfirmMessage: 'Delete “{name}”? Attendee list and records will also be removed.',
    deleteSuccess: 'Deleted',
    type: 'Check-in type',
    typeSearch: 'Search',
    typeLocate: 'Location',
    typeScan: 'QR code',
    status: 'Enabled',
    statusOn: 'On',
    statusOff: 'Off',
    needPrint: 'Need printing',
    needPrintYes: 'Yes',
    needPrintNo: 'No',
    timeWindow: 'Time window',
    startTime: 'Start',
    endTime: 'End',
    startAfterActivity: 'Check-in start cannot be later than the event start ({time})',
    startAfterActivityHint: 'Start time cannot be later than the event start: {time}',
    address: 'Address',
    addressPh: 'Optional; defaults to the event address',
    latitude: 'Latitude',
    longitude: 'Longitude',
    radius: 'Radius (m)',
    radiusHint: 'Required for location check-in',
    customFields: 'Custom columns',
    fieldKey: 'Field key',
    fieldLabel: 'Display name',
    fieldKeyPh: 'e.g. company, seat',
    fieldLabelPh: 'Name shown to guests',
    addField: 'Add field',
    fieldsSection: 'Extra attendee fields',
    fieldsSectionHint: 'Used in the import template, admin list and success page.',
    fieldsTemplateTip: 'After saving, download the attendee template again so it uses these display names.',
    fieldIncomplete: 'Each field needs both a key and a display name',
    fieldKeyInvalid: 'Keys must start with a lowercase letter and only use letters, numbers and underscores',
    fieldKeyDuplicate: 'Field keys must be unique',
    successButtons: 'Success buttons',
    successSection: 'Success page buttons',
    successHint: 'Link buttons need a full URL. Popup buttons need an image. Two buttons per row; an odd last button is centered.',
    successImageHint: 'Use PNG or JPG for QR codes and keep the name within 8 characters.',
    btnName: 'Name',
    btnNamePh: 'e.g. View agenda',
    btnNameRequired: 'Button name is required',
    btnLink: 'Link',
    btnImage: 'Image',
    btnPopup: 'Popup image',
    btnUrl: 'https://…',
    btnNeedUrl: 'Button {n} needs a full URL',
    btnNeedImage: 'Button {n} needs an uploaded image',
    btnUpload: 'Upload',
    btnReupload: 'Replace',
    btnUploadFailed: 'Image upload failed',
    addButton: 'Add button',
    entryUrls: 'Public URLs',
    urlH5: 'Guest H5',
    urlScanDesk: 'Scan desk',
    urlPrintDesk: 'Print desk',
    openQr: 'Open QR code',
    entryQrTip: 'Scan the QR code or copy the link below',
    save: 'Save check-in',
    saveSuccess: 'Saved',
    copySuccess: 'Copied',
    copyFailed: 'Copy failed',
    filterKeyword: 'Search name / phone',
    filterStatus: 'Status',
    statusUnsigned: 'Not checked in',
    statusSigned: 'Checked in',
    import: 'Import',
    export: 'Export',
    exportTemplate: 'Download template',
    importTip: 'Excel must include Name and Phone. Custom columns follow the settings. Duplicate phones in this check-in are updated. Max 5000 rows.',
    importDrop: 'Drop Excel here or click to upload',
    importEmpty: 'No data rows to import',
    importReady: '{n} rows parsed, confirm to save',
    importDone: 'Imported: {created} created, {updated} updated, {failed} failed',
    colName: 'Name',
    colMobile: 'Phone',
    phName: 'Enter name',
    phMobile: 'Enter phone number',
    colStatus: 'Status',
    colTime: 'Check-in time',
    colActions: 'Actions',
    addUser: 'Add person',
    editUser: 'Edit person',
    userNameRequired: 'Enter a name',
    userMobileRequired: 'Enter a phone number',
    userAddSuccess: 'Person added',
    userEditSuccess: 'Person saved',
    bgColor: 'Background color',
    bgImage: 'Background image',
    buttonText: 'Button text',
    buttonColor: 'Button color',
    clearBg: 'Remove image',
    designer: {
      selectNodeHint: 'Select a canvas component, or use Page / Search / Footer logo tabs',
      tabBusiness: 'Search',
      dividerGradient: 'Fade range',
      previewNeedSave: 'Save the design before previewing',
      paletteTitle: 'Components',
      paletteHint: 'Add images above or below the check-in form. Drag to reorder.',
      compImage: 'Image',
      businessLocked: 'Search, results and forms cannot be removed. Only styles can be edited.',
      devicePhone: 'Phone',
      deviceWide: 'Wide phone',
      reset: 'Reset',
      resetConfirm: 'Reset will clear the current design. Continue?',
      save: 'Save design',
      preview: 'Preview',
      propsTitle: 'Properties',
      propsHint: 'Page settings always apply. Click a canvas component to edit it.',
      sectionPage: 'Page',
      contentWidth: 'Content width',
      paddingTop: 'Top padding',
      paddingSide: 'Side padding',
      imageLimit: 'PNG, JPG or WEBP, max 10MB',
      imageType: 'Only PNG, JPG or WEBP is allowed',
      imageTooLarge: 'Image must be 10MB or smaller',
      bgSize: 'Background size',
      bgCover: 'Cover',
      bgContain: 'Contain',
      bgAuto: 'Original',
      bgPosition: 'Background position',
      posCenterTop: 'Top center',
      posLeftTop: 'Top left',
      posRightTop: 'Top right',
      posCenter: 'Center',
      bgRepeat: 'Repeat',
      repeatNo: 'No repeat',
      repeatYes: 'Tile',
      sectionImage: 'Selected · Image',
      position: 'Placement',
      posBefore: 'Above check-in',
      posAfter: 'Below check-in',
      align: 'Align',
      alignLeft: 'Left',
      alignCenter: 'Center',
      alignRight: 'Right',
      widthPct: 'Width %',
      radius: 'Radius',
      marginTop: 'Top margin (px)',
      marginBottom: 'Bottom margin (px)',
      clickToEdit: 'Click a canvas component to edit it. Business styles are below.',
      sectionPanel: 'Form panel',
      padding: 'Padding',
      shadow: 'Shadow',
      sectionInput: 'Input',
      inputHint: 'Colors stay at system defaults. Size can be changed.',
      height: 'Height',
      fontSize: 'Font size',
      sectionButton: 'Button',
      textColor: 'Text color',
      uploadHint: 'Select the component, then upload an image on the right',
      dropBefore: 'Drop here to show above the form',
      dropAfter: 'Drop here to show below the form'
    }
  },
  seating: {
    pageTitle: 'Seat assignments',
    tabQueryPages: 'Page editor',
    tabRecords: 'Seat table',
    add: 'Add',
    import: 'Import',
    export: 'Export',
    exportTemplate: 'Download template',
    adjust: 'Adjust seat',
    empty: 'No seat assignments yet',
    filterMeeting: 'All sessions',
    filterKeyword: 'Search name / seat no.',
    colId: 'ID',
    colSeatNo: 'Seat no.',
    colName: 'Name',
    colPhone: 'Phone',
    colSeatType: 'Seat type',
    colSession: 'Session',
    colRow: 'Row',
    colCol: 'Column',
    colRemark: 'Notes',
    typeNormal: 'Standard',
    typeVip: 'VIP',
    formTitleAdd: 'Add seat',
    formTitleEdit: 'Adjust seat',
    phName: 'Enter name',
    phPhone: 'Enter phone',
    phSeatNo: 'Enter seat number',
    phSession: 'Select session',
    phRemark: 'Optional',
    seatNoRequired: 'Seat number is required',
    meetingRequired: 'Please select a session',
    createSuccess: 'Seat added',
    updateSuccess: 'Seat updated',
    deleteSuccess: 'Seat deleted',
    deleteConfirm: 'Delete seat {seatNo}?',
    importTip: 'Columns: ID, seat no., name, phone, seat type, session (meeting ID, optional), row, column, notes. Existing IDs are updated. Session may be blank. Download the template first. Max 1000 rows.',
    importDrop: 'Drop Excel here or click to upload (.xlsx / .xls)',
    importTypeError: 'Please upload an .xlsx or .xls file',
    importEmpty: 'No data rows to import',
    importParseFailed: 'Failed to parse Excel',
    importReady: '{n} rows parsed, confirm to save',
    importDone: 'Imported: {created} created, {updated} updated, {failed} failed',
    importRowFail: 'Row {row}: {message}',
    enterEditor: 'Seat query editor',
    queryList: {
      pageTitle: 'Seat query pages',
      add: 'New query page',
      empty: 'No seat query pages yet',
      filterName: 'Search by name',
      meetingNone: 'No session',
      colName: 'Name',
      colActivity: 'Activity',
      colSession: 'Session',
      colPageUrl: 'Page analysis',
      pageUrlBtn: 'Browse',
      editBtn: 'Page design',
      shareTitle: 'Page URL',
      shareTip: 'Scan the QR code or copy the link below',
      copyLink: 'Copy',
      copySuccess: 'Link copied',
      copyFailed: 'Copy failed, please copy manually'
    },
    queryEditor: {
      pageSelectPlaceholder: 'Select a saved page',
      pageNew: 'New query page',
      pageNamePlaceholder: 'Seat query + random suffix',
      dragToDelete: 'Drag here to delete',
      deviceNormal: 'Phone',
      deviceWide: 'Wide phone',
      browse: 'Preview',
      paletteTitle: 'Components',
      groupBasic: 'Basic',
      groupLayout: 'Layout',
      compText: 'Text',
      compImage: 'Image',
      compSeatMap: 'Seat map',
      compQueryBg: 'Query backdrop',
      compSpacer: 'Spacer',
      compDivider: 'Divider',
      compFloatButton: 'Floating button',
      canvasTitle: 'Preview',
      dragSort: 'Drag to reorder',
      propsTitle: 'Properties',
      selectNodeHint: 'Select a canvas component, or use Page / Query / Hint / Logo tabs',
      showComponent: 'Visible',
      tabProps: 'Props',
      tabPage: 'Page',
      tabQuery: 'Query',
      tabHint: 'Hints',
      tabLogo: 'Footer logo',
      fieldContent: 'Text',
      fieldFontSize: 'Font size',
      fieldFontWeight: 'Weight',
      fieldColor: 'Color',
      fieldAlign: 'Align',
      fieldWidth: 'Width (%)',
      fieldHeight: 'Height (px)',
      fieldRadius: 'Radius',
      fieldBgColor: 'Background color',
      alignLeft: 'Left',
      alignCenter: 'Center',
      alignRight: 'Right',
      weightRegular: 'Regular',
      weightMedium: 'Medium',
      weightSemibold: 'Semibold',
      weightBold: 'Bold',
      seatMapHint: 'Upload a clear seating layout. JPG, PNG and GIF are supported.',
      queryBgHint: 'Independent layer — it does not wrap other components. Select it via the blue handle, the component library, or empty space around the query form. Later items stack on top.',
      queryBgSingle: 'Only one query backdrop can be added',
      queryBgSelectHint: 'Already added — click to select',
      queryBgHandle: 'Select backdrop; drag handle to reorder',
      fieldPosition: 'Position',
      fieldOffsetY: 'Top (px)',
      fieldPaddingTop: 'Padding top (px)',
      fieldPaddingBottom: 'Padding bottom (px)',
      queryType: 'Query type',
      queryTypeName: 'Name only',
      queryTypePhone: 'Phone only',
      queryTypeBoth: 'Name + phone',
      matchMode: 'Match mode',
      matchExact: 'Exact',
      matchFuzzy: 'Fuzzy',
      inputWidth: 'Input width (%)',
      inputRadius: 'Input radius',
      queryAlign: 'Input position',
      buttonPlacement: 'Button position',
      buttonRow: 'Same row as inputs',
      buttonBelow: 'Below inputs',
      buttonText: 'Button text',
      buttonRadius: 'Button radius',
      buttonBgColor: 'Button color',
      buttonFontSize: 'Button font size',
      buttonTextColor: 'Button text color',
      successHint: 'Success message',
      replaceQueryOnSuccess: 'Replace queryer',
      replaceQueryOnSuccessHelp: 'On success the queryer is hidden and the success message is shown in its place. Guests can tap Back to search again.',
      successHintHelp: 'Shown on success. {seat_number} is replaced with the seat number.',
      backToQuery: 'Back',
      seatNumberOwnLine: 'Seat number on its own line',
      showGuestName: 'Show name',
      seatFontSize: 'Seat number font size',
      errorHint: 'Error message',
      errorHintHelp: 'Shown as a toast for a few seconds when no seat is found.',
      hintText: 'Copy',
      removeComponent: 'Remove component',
      saveSuccess: 'Seat query page saved',
      nameDuplicate: 'This name is already used. Please change it before saving.',
      saveFailed: 'Save failed, please try again',
      previewNeedSave: 'Save the page before previewing',
      resetConfirm: 'Reset will restore the default layout (not saved until you confirm). Continue?',
      resetDone: 'Default layout restored. Save to apply.',
      switchUnsaved: 'Unsaved changes will be discarded when switching pages. Continue?',
      switchTitle: 'Switch page',
      h5NotFound: 'This seat query page does not exist yet',
      phName: 'Enter name',
      phPhone: 'Enter phone',
      needName: 'Please enter a name',
      needPhone: 'Please enter a phone number',
      searchFailed: 'Search failed, please try again'
    }
  },
  eventTime: 'Event time',
  timeStartPlaceholder: 'Start',
  timeEndPlaceholder: 'End',
  list: {
    welcomeTitle: 'Welcome!',
    welcomeSubtitle: 'Bandu Cloud event platform',
    welcomePromoTitle: 'Live photo AI retouch is here',
    welcomePromoDesc: 'AI-powered retouch for every frame of your event.',
    welcomeDocBtn: 'View docs',
    colIndex: '#',
    colActivityInfo: 'Event',
    colStatus: 'Status',
    colActions: 'Actions',
    meetingSessions: '{n} sessions',
    statTotalActivities: 'Total events',
    statOngoingSub: '{n} in progress',
    statTotalRegistrations: 'Total registrations',
    statTotalCheckins: 'Total check-ins',
    statTotalIncome: 'Total revenue',
    statPageHint: 'This page',
    unitPerson: '',
    unitTimes: '',
    unitWan: '0k',
    quickEnterSettings: 'Settings',
    quickSchedule: 'Schedule',
    quickRegRecords: 'Registrations',
    quickSeating: 'Seating',
    quickItinerary: 'Itinerary',
    quickCheckin: 'Check-in management',
    quickDecorate: 'Design',
    quickMicrosite: 'Microsite',
    quickAgenda: 'Agenda',
    quickJoinReg: 'Register',
    quickRegRecordsJoined: 'Reg. records',
    quickSeatingInfo: 'Seating info',
    quickHotel: 'Hotel',
    quickOrders: 'Orders',
    tagJoined: 'Joined',
    tagCreated: 'Created',
    filterAllOwnership: 'All events',
    filterJoined: 'Joined',
    filterCreated: 'Created',
    inviterLabel: 'Invited by: {name}',
    opViewDetail: 'View details',
    createActivity: 'Create event',
    topForm: 'Forms',
    topItinerary: 'Itinerary',
    topPayment: 'Payments',
    topAudit: 'Review list',
    topAssociation: 'Registration link',
    allActivities: 'All events ({count})',
    advancedFilter: 'Advanced filter',
    searchNameOnly: 'Search by name',
    countdown: 'Countdown',
    share: 'Share',
    sort: 'Sort',
    qrShare: 'QR code',
    addressUnset: 'No location set',
    statusUnset: '—',
    statusEnded: 'Ended',
    statusOngoing: 'In progress',
    countdownDays: '{days}d',
    opActivity: 'Event',
    opSchedule: 'Schedule',
    opShare: 'Share',
    opDecorate: 'Design',
    opPayment: 'Pay',
    opRegistration: 'Reg.',
    opCheckin: 'Check-in',
    opSeating: 'Seats',
    opDelete: 'Delete',
    statusAutoTip: 'Status is derived from start/end times: in progress, ended, or countdown.',
    statAll: 'All events',
    statOngoing: 'In progress',
    statEnded: 'Ended',
    statUnset: 'No schedule',
    filterAllStatus: 'All statuses',
    filterOngoing: 'In progress',
    filterEnded: 'Ended',
    filterUnset: 'Unset',
    unitEvent: ''
  },
  /** Invited / grant activity workspace */
  invited: {
    navGroup: 'Invited activities',
    navIntro: 'Event site',
    navAgenda: 'Agenda',
    navRegistration: 'Register',
    navOrders: 'Orders',
    introTitle: 'Event site',
    agendaTitle: 'Event agenda',
    regTitle: 'Registration',
    ordersTitle: 'Orders',
    openHome: 'Open in new tab',
    phonePreviewTitle: 'Microsite home preview',
    phoneHint: 'Preview of the event microsite home; scroll inside the phone frame',
    noHomePage: 'This event has no microsite home page yet',
    loadHomeFailed: 'Failed to load microsite home',
    invalidActivity: 'Invalid activity ID',
    labelTime: 'Date',
    labelVenue: 'Venue',
    labelInviter: 'Host / Inviter',
    sectionIntro: 'Introduction',
    sectionHighlights: 'Highlights',
    contactLabel: 'Contact person',
    goRegister: 'Register now'
  },
  /** Hotel library (standalone; mock data until API is ready) */
  hotel: {
    listTitle: 'Hotel list',
    addHotel: 'Add hotel',
    bannerTitle: 'Hotel library — manage all available hotels',
    bannerHtml: '📋 Maintain hotel basics here: name, address, facilities, package templates, facade photos, etc.<br>🔗 <b>Hotel library is separate from events</b>: configure hotels here, then link them per event under Event settings → Hotels (with per-event price and room counts).<br>💡 Complete hotel info (packages & images) here first, then link them in each event.',
    empty: 'No hotels yet. Click Add hotel to create one.',
    editDetail: 'Edit details',
    backToList: 'Back to hotel list',
    detailTitle: 'Hotel details',
    saveChanges: 'Save changes',
    tabInfo: '🏢 Basic info',
    tabPackages: '🛏️ Packages',
    tabEnv: '📸 Environment',
    tabFacilities: '🏨 Facilities & surroundings',
    tabOrders: '📋 Orders',
    ordersComingSoon: 'Orders coming soon',
    facadeTitle: 'Facade photos',
    uploadImage: '📷 Upload',
    replace: 'Replace',
    addFacade: 'Add facade photo',
    imageHint: '💡 Prefer exterior/facade photos. Max 5MB each, up to 20. Preview locally; upload on Save.',
    facadeMaxError: 'You can upload at most 20 facade photos',
    name: 'Hotel name',
    namePlaceholder: 'e.g. Crowne Plaza Guangzhou Tianhe',
    nameRequired: 'Hotel name is required',
    star: 'Star rating',
    starUnit: '-star hotel',
    starUnset: 'Not set',
    address: 'Hotel address',
    addressPlaceholder: 'e.g. 689 Tianhe Road, Tianhe District, Guangzhou',
    addressRequired: 'Hotel address is required',
    phone: 'Phone',
    phonePlaceholder: 'Enter hotel phone',
    phoneRequired: 'Hotel phone is required',
    icon: 'Hotel icon',
    maxRooms: 'Max rooms',
    maxRoomsPlaceholder: '0',
    maxRoomsRequired: 'Max rooms is required',
    roomTags: 'Room tags',
    roomTagsPlaceholder: 'e.g. Twin ¥580/night, King ¥680/night (comma-separated)',
    contact: 'Contact person',
    contactPhone: 'Contact phone',
    tags: 'Tags',
    tagsPlaceholder: 'Comma-separated tags',
    description: 'Hotel description',
    descriptionPlaceholder: 'Describe features, facilities, surroundings, etc.',
    confirmCreate: 'Create hotel',
    createSuccess: 'Hotel created',
    createFailed: 'Failed to create hotel',
    saveSuccess: 'Saved',
    saveFailed: 'Failed to save',
    loadFailed: 'Failed to load hotels',
    loadDetailFailed: 'Failed to load hotel details',
    deleteConfirm: 'Delete hotel “{name}”?',
    deleteSuccess: 'Deleted',
    deleteFailed: 'Failed to delete',
    uploadSuccess: 'Uploaded',
    uploadFailed: 'Upload failed',
    imageSizeError: 'Image must be 5MB or smaller',
    imageTypeError: 'Only JPG, PNG, and WebP are supported',
    pkgList: 'Room packages',
    addPkg: 'Add package',
    editPkg: 'Edit package',
    pkgEmpty: 'No packages yet',
    perNight: 'night',
    roomCount: 'Total rooms',
    roomUnit: '',
    booked: 'Booked',
    remain: 'Left',
    breakfast: 'Breakfast',
    breakfastYes: 'Breakfast included',
    breakfastNo: 'No breakfast',
    breakfastOptional: 'Optional breakfast',
    pkgImages: 'Package images',
    addImage: 'Add image',
    pkgImageHint: '💡 Prefer real room photos. Max 5MB. Preview locally; upload when you confirm the package.',
    pkgName: 'Package name',
    pkgNameRequired: 'Package name is required',
    beds: 'Bed type',
    area: 'Area',
    price: 'Price (CNY/night)',
    pkgDesc: 'Description',
    pkgSaveSuccess: 'Package saved',
    pkgSaveFailed: 'Failed to save package',
    pkgDeleteConfirm: 'Delete this package?',
    pkgDeleteSuccess: 'Package deleted',
    pkgDeleteFailed: 'Failed to delete package',
    envTip: 'Environment photos show lobby, restaurant, meeting rooms, etc. Preview locally; upload on Save.',
    envTitle: 'Hotel photos',
    clickUpload: 'Upload',
    facilitiesTitle: 'Facilities',
    facilityPlaceholder: 'Enter new facility name',
    add: 'Add',
    surroundingsTitle: 'Surroundings',
    surroundingsPlaceholder: 'Nearby attractions, transit, dining, etc. (plain text or simple HTML)',
    surroundingsHint: 'Saved to the surroundings field as plain text or HTML'
  }
}
